import React, { useState, useEffect, useRef } from 'react';

const sliderItems = [
  {
    id: 4,
    name: "Behzad Ghafoor",
    description: "Transformation Specialist with a proven and mind blowing track record of 3 years and 4 major transformation.",
    image: "man4.png",
    bgColor: "bg-gray-200"
  },
  {
    id: 1,
    name: "Kaab Ghafoor",
    description: "A 21 year old powerlifter who had a total of 630 KG at the age of 19.",
    image: "kaab.jpeg",
    bgColor: "bg-teal-200"
  },
  {
    id: 3,
    name: "Dr. Nouman Akram",
    description: "(Bachelor of Medicine & Bachelor of Surgery).",
    image: "doctor1.jpg",
    bgColor: "bg-slate-700"
  },
  {
    id: 2,
    name: "Mr. Ali Butt",
    description: "Weight Lifting & Powerlifting coach, ISSA Level 3 CPT, National Weight Lifting Champion & Assistant Director Sports UE.",
    image: "ali_powerlifting.jpg",
    bgColor: "bg-orange-300"
  }
];

const HoverSlider = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPlaying, setIsPlaying] = useState(true);
  const intervalRef = useRef(null);

  const cardWidth = 320;
  const duplicatedItems = [...sliderItems, ...sliderItems, ...sliderItems];

  useEffect(() => {
    if (isPlaying) {
      startAutoPlay();
    } else {
      stopAutoPlay();
    }
    return () => stopAutoPlay();
  }, [isPlaying]);

  const startAutoPlay = () => {
    stopAutoPlay();
    intervalRef.current = setInterval(() => {
      setCurrentIndex(prevIndex => {
        const nextIndex = prevIndex + 1;
        if (nextIndex >= sliderItems.length) {
          return 0;
        }
        return nextIndex;
      });
    }, 2000);
  };

  const stopAutoPlay = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  };

  const handleMouseEnter = () => {
    setIsPlaying(false);
  };

  const handleMouseLeave = () => {
    setIsPlaying(true);
  };

  const handleDotClick = (index) => {
    setCurrentIndex(index);
    setIsPlaying(false);
    setTimeout(() => setIsPlaying(true), 3000);
  };

  const translateX = -(currentIndex * cardWidth);

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50 py-16">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold text-[#2B4C7E] mb-6">
            Meet Our Expert Team
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Discover our passionate professionals who are dedicated to transforming lives through fitness and wellness
          </p>
        </div>

        {/* Slider Container */}
        <div className="relative overflow-hidden rounded-3xl">
          <div 
            className="flex transition-transform duration-1000 ease-in-out"
            style={{
              transform: `translateX(${translateX}px)`,
              width: `${duplicatedItems.length * cardWidth}px`
            }}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
          >
            {duplicatedItems.map((item, index) => (
              <div
                key={`${item.id}-${Math.floor(index / sliderItems.length)}`}
                className="flex-shrink-0 px-4"
                style={{ width: '20rem' }}
              >
                <div
                  className="group relative overflow-hidden cursor-pointer transition-all duration-500 ease-out w-full h-96 rounded-2xl shadow-xl hover:shadow-2xl hover:scale-105 border border-white/20"
                  style={{
                    backgroundImage: `url(${item.image})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                  }}
                >
                  <div className="absolute inset-0 bg-black/20 group-hover:bg-black/70 transition-all duration-500" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />

                  <div className="absolute bottom-0 left-0 right-0 p-6 text-white opacity-0 group-hover:opacity-100 transition-all duration-500 transform translate-y-4 group-hover:translate-y-0">
                    <div className="transform transition-transform duration-300 group-hover:-translate-y-2">
                      <h3 className="text-2xl font-bold mb-2 text-white">
                        {item.name}
                      </h3>
                      <p className="text-sm leading-relaxed text-white/90">
                        {item.description}
                      </p>
                    </div>
                    <div className="absolute -top-2 left-6 w-12 h-1 bg-white/60 rounded-full transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500 origin-left"></div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Navigation Dots */}
        <div className="flex justify-center mt-12 space-x-3">
          {sliderItems.map((_, index) => (
            <button
              key={index}
              className={`transition-all duration-300 rounded-full border-2 ${
                currentIndex === index 
                  ? 'w-12 h-4 bg-[#2B4C7E] border-[#2B4C7E]' 
                  : 'w-4 h-4 bg-transparent border-gray-300 hover:border-[#2B4C7E] hover:bg-gray-100'
              }`}
              onClick={() => handleDotClick(index)}
              aria-label={`Go to slide ${index + 1}`}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default HoverSlider;